import { base64ToArray, cryptoPairsFromArray, decryptWithAes, decryptWithRsaBlockCipher, } from '@lucidlink/ts-crypto/crypto';
import { TimeCachedValue } from '#sdk/utils/time-cached-value';
import { PendingMemberError } from '../workspace-crypto.error';
import { MemberCrypto } from './member-crypto';
export class MemberCryptoFromAccountCrypto extends MemberCrypto {
    member;
    accountCrypto;
    logger;
    constructor(member, accountCrypto, logger) {
        super();
        this.member = member;
        this.accountCrypto = accountCrypto;
        this.logger = logger;
        this.logger = logger.child({ class: 'MemberCrypto' });
    }
    verifyAndGetCurrentMemberKeys() {
        return this.memberKeys.get();
    }
    getWorkspaceCommonKeyArray() {
        return this.workspaceCommonKeyArray.get();
    }
    verifyAndGetCurrentMemberInvitationKeys() {
        return this.invitationKeys.get();
    }
    memberKeys = new TimeCachedValue(async () => {
        if (!this.member.ePrivateKeyByUserKey) {
            throw new PendingMemberError();
        }
        const memberPublicKeyArray = base64ToArray(this.member.publicKey);
        const { buffer: memberPrivateKeyArray } = await decryptWithAes(this.member.ePrivateKeyByUserKey, await this.accountCrypto.getAccountKey());
        const memberKeys = await cryptoPairsFromArray(memberPublicKeyArray, memberPrivateKeyArray);
        await this.verifyPublicPrivateKeyPair(memberKeys.signPair, 'Member public and private keys do not match');
        return memberKeys;
    }, { expirationTime: 'neverExpire' });
    workspaceCommonKeyArray = new TimeCachedValue(async () => {
        const invitationKeys = await this.invitationKeys.get();
        return await decryptWithRsaBlockCipher(this.member.invitation.eWorkspaceCommonKeyByInvitationKey, invitationKeys.encryptPair.privateKey);
    }, { expirationTime: 'neverExpire' });
    invitationKeys = new TimeCachedValue(async () => {
        const memberKeys = await this.verifyAndGetCurrentMemberKeys();
        const invitationPrivateKeyArray = await decryptWithRsaBlockCipher(this.member.eInvitationPrivateKeyByMemberKey, memberKeys.encryptPair.privateKey);
        const invitationPublicKeyArray = base64ToArray(this.member.invitation.publicKey);
        const invitationKeys = await cryptoPairsFromArray(invitationPublicKeyArray, invitationPrivateKeyArray);
        await this.verifyPublicPrivateKeyPair(invitationKeys.signPair, 'Invitation public and private keys do not match');
        return invitationKeys;
    }, { expirationTime: 'neverExpire' });
}
